import { Controller } from "@hotwired/stimulus"

// Handles checkbox selection + View In Dashboard for alert result tables.
// Mirrors the Market Finder selection pattern (max 5 geographies).
export default class extends Controller {
  static targets = ["checkbox", "viewBtn", "count", "clearBtn"]

  connect() {
    this.maxSelections = 5
    this.updateState()
  }

  toggle() {
    this.updateState()
  }

  updateState() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length
    const atMax = count >= this.maxSelections

    this.checkboxTargets.forEach(cb => {
      cb.disabled = atMax && !cb.checked
    })

    if (this.hasViewBtnTarget) {
      this.viewBtnTarget.disabled = count === 0
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count > 0 ? `${count} selected` : ""
    }
    if (this.hasClearBtnTarget) {
      this.clearBtnTarget.style.display = count > 0 ? "" : "none"
    }
  }

  clearAll() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.updateState()
  }

  openDashboard(event) {
    event.preventDefault()
    const ids = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (ids.length === 0) return

    const params = new URLSearchParams()
    ids.forEach(id => params.append("geography_ids[]", id))
    window.open(`/dashboard?${params.toString()}&period=90d`, "_blank")
  }
}
